/**
 * @fileoverview initialize all carousels with the `.odo-carousel` class.
 */

import $ from 'jquery';
import OdoCarousel from 'js/odo-carousel';
import './odo-carousel.scss';

export default {
  initializeAll() {
    return $('.odo-carousel').map((i, el) => new OdoCarousel(el)).get();
  },
};
